import React, { Component } from 'react';

class Resource extends Component {
	render() {
		return (
			<li className="list__item">

				<div className="item-actions elementary">

					<div className="item-actions__item">

						<div className="icon-text icon-text--download">
							{this.props.data.name}
						</div>

					</div>

					<div className="item-actions__actions">
							
						<ul className="actions">

							{this.props.data.files.map((file, index) =>
							<li key={index} className="actions__item">

								<a href={file.url} target="_blank" className="actions__item-link" itemScope itemType="http://schema.org/DigitalDocument">
									<meta content={this.props.data.name} itemProp="name" />
									<meta content={file.url} itemProp="url" />
									<meta content="application/pdf" itemProp="fileFormat" />
									Download {file.name}
								</a>

							</li>
							)}

						</ul>

					</div>

				</div>

			</li>
		);
	}
}

export default Resource;
